/**
 * Displays a feedback email address.
 */
const FeedbackEmail = () => (
	<a href="mailto:feedback@howickweather.co.nz">feedback@howickweather.co.nz</a>
);

export default FeedbackEmail;



// WEBPACK FOOTER //
// ./components/feedback-email/index.js